module.exports = __webpack_public_path__ + "static/media/HT.ebf92be8.svg";